import React from 'react';
import PropTypes from 'prop-types';
import '../containers/Home.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faVideo } from '@fortawesome/free-solid-svg-icons';

/**
 * Card for Próximos Eventos (in-person events)
 * @param {object} props
 * @param {object} props.show - Show/event data
 * @param {function} props.renderGenreIcon - Function to render genre icon
 */
export function UpcomingEventCard({ show, renderGenreIcon }) {
  return (
    <div className="upcoming-card">
      <div className="upcoming-card__image-wrapper">
        <img className="upcoming-card__image" src={show.main_image} alt={show.fullname} />
        <div className="upcoming-card__date-badge">
          <span className="upcoming-card__date-day">{show.day}</span>
          <span className="upcoming-card__date-month">{show.month}</span>
        </div>
        <div className="upcoming-card__gradient" />
      </div>
      <div className="upcoming-card__content">
        <div className="upcoming-card__row upcoming-card__row--badges">
          {/* <span className="upcoming-card__badge upcoming-card__badge--presencial">PRESENCIAL</span> */}
          {show.venue && (
            <span className={`upcoming-card__badge ${show.venue === 'Online' ? 'upcoming-card__badge--online' : 'upcoming-card__badge--presencial'}`}>
              <FontAwesomeIcon 
                icon={show.venue === 'Online' ? faVideo : faMapMarkerAlt} 
                style={{ marginRight: '4px' }} 
              />
              {show.venue}
            </span>
          )}
        </div>
        <div className="upcoming-card__row upcoming-card__row--title" style={{flex: 1, alignItems: 'flex-start'}}>
          <div className="upcoming-card__title">{show.fullname}</div>
        </div>
        <div className="upcoming-card__row upcoming-card__row--footer">
          <div className="upcoming-card__footer">
            <div className="upcoming-card__time">
              <span className="upcoming-card__time-icon" role="img" aria-label="clock">🕒</span> {show?.settings?.has_show_dates ? 'múltiples funciones' : show.hour}
            </div>
            <div className="upcoming-card__genre">{renderGenreIcon(show)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

UpcomingEventCard.propTypes = {
  show: PropTypes.object.isRequired,
  renderGenreIcon: PropTypes.func.isRequired,
}; 